// Generouted, changes to this file will be overriden
/* eslint-disable */

import { components, hooks, utils } from '@generouted/react-router/client'

export type Path =
  | `/`
  | `/access-denied`
  | `/roles-and-permissions`
  | `/roles-and-permissions/:appRoleId`
  | `/roles-and-permissions/:appRoleId/details`
  | `/roles-and-permissions/:appRoleId/permissions`
  | `/roles-and-permissions/:appRoleId/permissions/:app`
  | `/roles-and-permissions/:appRoleId/users`
  | `/user-management`
  | `/user-not-active`

export type Params = {
  '/roles-and-permissions/:appRoleId': { appRoleId: string }
  '/roles-and-permissions/:appRoleId/details': { appRoleId: string }
  '/roles-and-permissions/:appRoleId/permissions': { appRoleId: string }
  '/roles-and-permissions/:appRoleId/permissions/:app': { appRoleId: string; app: string }
  '/roles-and-permissions/:appRoleId/users': { appRoleId: string }
}

export type ModalPath = never

export const { Link, Navigate } = components<Path, Params>()
export const { useModals, useNavigate, useParams } = hooks<Path, Params, ModalPath>()
export const { redirect } = utils<Path, Params>()
